import * as dayjs from 'dayjs';
import { Entidade } from './entidade';
import { ProdutoNota } from './produto-nota.model';
import { Status } from './status.model';
import { TipoDocumento } from './tipo-documento';
import { INotaFiscalImagem } from './nota-fiscal-imagem.model';
import { INotaFiscalReplica } from './nota-fiscal-replica.model';
import { IConfigTipoDocumento } from './config-tipo-documento.model';
import { Account } from './account.model';
export interface ICarCompra {
    compraId?: number | null;
    nfDate?: dayjs.Dayjs  | null;
    nfId?: number | null;
    nfNome?: string | null;
    userId?: number | null;
}
export interface INotaFiscal {
  id?: number;
  numeroNota?: string | null;
  timestamp?: dayjs.Dayjs | null;
  status?: Status | null;
  produtoNota?: ProdutoNota | null;
  quantidade?: number | null;
  imagemContentType?: string | null;
  imagem?: string | null;
  imagens?: INotaFiscalImagem[] | null;
  observacao?: string | null;
  tipoDocumento?: TipoDocumento | null;
  configTipoDocumento?: IConfigTipoDocumento | null;
  qtdeGeradaConfig?: number | null;
  qtdeDestruidaConfig?: number | null;
  descricaoConfig?: string | null;
  entidade?: Entidade | null;
  areaCar?: number | null;
  areaPreservacao?: number | null;
  latitude?: string | null;
  exercicio?: number | null;
  replicas?: INotaFiscalReplica[] | null;
  imagemMapaContentType?: string | null;
  imagemMapa?: string | null;
  user?: Account | null;
  produtor?: String | null;
  aprovedDate?: dayjs.Dayjs | null;

}

export class NotaFiscal implements INotaFiscal {
  constructor(
    public id?: number,
    public numeroNota?: string | null,
    public timestamp?: dayjs.Dayjs | null,
    public status?: Status | null,
    public produtoNota?: ProdutoNota | null,
    public quantidade?: number | null,
    public imagemContentType?: string | null,
    public imagem?: string | null,
    public imagens?: INotaFiscalImagem[] | null,
    public observacao?: string | null,
    public tipoDocumento?: TipoDocumento | null,
    public configTipoDocumento?: IConfigTipoDocumento | null,
    public qtdeGeradaConfig?: number | null,
    public qtdeDestruidaConfig?: number | null,
    public descricaoConfig?: string | null,
    public entidade?: Entidade | null,
    public areaCar?: number | null,
    public areaPreservacao?: number | null,
    public latitude?: string | null,
    public exercicio?: number | null,
    public replicas?: INotaFiscalReplica[] | null,
    public imagemMapaContentType?: string | null,
    public imagemMapa?: string | null,
    public user?: Account | null,
    public aprovedDate?: dayjs.Dayjs | null
  ) { }
}

export function getNotaFiscalIdentifier(notaFiscal: INotaFiscal): number | undefined {
  return notaFiscal.id;
}
